<template>
  <div class="home">
    <v-container class="home__container">
      <!-- Info usuario -->
      <v-card class="mb-8 rounded-lg" elevation="0" outlined>
        <div class="d-flex align-center pa-4">
          <v-avatar color="primary" size="44" class="mr-4">
            <span class="white--text text-h6 font-weight-bold">{{ userInitial }}</span>
          </v-avatar>
          <div>
            <p class="text-body-1 font-weight-bold mb-0 primary--text">{{ username }}</p>
            <v-chip x-small :color="rolColor" dark class="mt-1">{{ userRol }}</v-chip>
          </div>
          <v-spacer></v-spacer>
          <span class="grey--text text-caption d-none d-sm-block mr-1">Sesion activa</span>
          <v-icon small color="success" class="mr-4">mdi-circle</v-icon>
          <v-btn text small color="grey darken-1" class="logout-btn" @click="logoutDialog = true">
            <v-icon small left>mdi-logout</v-icon>
            <span class="d-none d-sm-inline">Cerrar sesion</span>
          </v-btn>
        </div>
      </v-card>

      <div class="home__header mb-6">
        <h1 class="text-h5 text-md-h4 primary--text font-weight-bold">Panel de control</h1>
        <p class="grey--text text--darken-1 text-body-2 mt-1 mb-0">Selecciona un modulo para comenzar</p>
      </div>

      <v-row class="home__grid" justify="start">
        <v-col
          cols="6"
          sm="4"
          md="3"
          v-for="item in menu"
          :key="item.name"
        >
          <menu-item :itemMenu="item"></menu-item>
        </v-col>
      </v-row>
    </v-container>

    <!-- Modal cerrar sesion -->
    <v-dialog v-model="logoutDialog" max-width="380" persistent>
      <v-card class="rounded-lg text-center pa-2">
        <v-card-text class="pt-6 pb-2">
          <v-avatar color="#FFF3E0" size="56" class="mb-4">
            <v-icon color="orange darken-2" size="28">mdi-logout</v-icon>
          </v-avatar>
          <h3 class="text-subtitle-1 font-weight-bold primary--text mb-2">Cerrar sesion</h3>
          <p class="text-body-2 grey--text text--darken-1 mb-0">
            Estas seguro que deseas cerrar tu sesion? Tendras que iniciar sesion nuevamente para acceder.
          </p>
        </v-card-text>
        <v-card-actions class="justify-center pb-4 pt-2">
          <v-btn outlined color="grey" class="dialog-btn" @click="logoutDialog = false">Cancelar</v-btn>
          <v-btn depressed color="error" class="dialog-btn" @click="logout">Si, cerrar sesion</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "Home",
  mounted() {
    const userData = JSON.parse(localStorage.LCInternet).user;
    this.username = userData.username;
    this.userRol = userData.rol;

    this.modules.forEach((e) => {
      if (e.users.includes(userData.rol)) {
        delete e.users;
        this.menu.push(e);
      }
    });
  },
  computed: {
    userInitial() {
      return this.username ? this.username.charAt(0).toUpperCase() : "";
    },
    rolColor() {
      return this.userRol === "admin" ? "#2E347A" : "#607D8B";
    },
  },
  components: {
    MenuItem: () => import("../components/MenuItem"),
  },
  methods: {
    logout() {
      this.logoutDialog = false;
      localStorage.removeItem("LCInternet");
      this.$router.push({ name: "Login" });
    },
  },
  data: () => ({
    logoutDialog: false,
    username: "",
    userRol: "",
    modules: [
      {
        name: "CLIENTES",
        icon: "icon-customers",
        to: "Clients",
        users: ["admin", "user"],
      },
      {
        name: "CLIENTE TEMPORAL",
        icon: "icon-menu-internet-movil",
        to: "MobileClients",
        users: ["admin", "user"],
      },
      {
        name: "ANTENAS",
        icon: "icon-packages",
        to: "Antennas",
        users: ["admin", "user"],
      },
      {
        name: "CORTE DE CAJA",
        icon: "icon-bill",
        to: "CorteCaja",
        users: ["admin", "user"],
      },
      {
        name: "USUARIOS",
        icon: "IconUsers",
        to: "Users",
        users: ["admin"],
      },
      {
        name: "ACTIVIDAD",
        icon: "icon-chargers",
        to: "AuditLogs",
        users: ["admin"],
      },
    ],
    menu: [],
  }),
};
</script>

<style lang="scss" scoped>
.home {
  min-height: calc(100vh - 80px);
  background-color: #f4f5f7;
  display: flex;
  align-items: flex-start;

  &__container {
    max-width: 960px;
    padding-top: 16px;
    padding-bottom: 48px;
  }

  &__header {
    text-align: left;
  }

  &__grid {
    margin: 0 -8px;
  }
}

.logout-btn {
  text-transform: none;
  letter-spacing: 0.02em;
  font-weight: 500;
}

.dialog-btn {
  text-transform: none;
  letter-spacing: 0.02em;
  min-width: 130px;
}
</style>
